import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface GuideStep {
    title: string;
    description: string;
    iconType?: string;
}

@Component({
    selector: 'app-guide-modal',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './guide-modal.html',
    styleUrl: './guide-modal.scss'
})
export class GuideModal {
    @Input() isVisible = false;
    @Output() close = new EventEmitter<void>();

    currentStepIndex = 0;

    steps: GuideStep[] = [
        {
            title: 'How to customize widgets?',
            description: 'Easily add new widgets, adjust their size, or remove them anytime.',
            iconType: 'intro'
        },
        {
            title: 'Customize Widgets',
            description: 'Tap the settings icon to enter widget customization mode.',
            iconType: 'customize'
        },
        {
            title: 'Drag and Drop',
            description: 'Press and hold a widget to drag and reorder it.',
            iconType: 'drag'
        },
        {
            title: 'Add Widgets',
            description: 'Tap "Add Widgets" to browse and select new widgets for your dashboard.',
            iconType: 'add'
        },
        {
            title: 'Pick a Widget',
            description: 'Choose from the available widgets and tap the + button to add it.',
            iconType: 'pick'
        },
        {
            title: 'Resize Widgets',
            description: 'Drag the edges to make a widget larger or smaller.',
            iconType: 'resize'
        },
        {
            title: 'Edit Widgets',
            description: 'Tap the pencil icon on a widget to change its size or delete it.',
            iconType: 'manageEdit'
        },
        {
            title: 'Edit or Delete Widgets',
            description: 'Tap the pencil icon on a widget to change its size or delete it.',
            iconType: 'manage'
        }
    ];

    get currentStep(): GuideStep {
        return this.steps[this.currentStepIndex];
    }

    nextStep() {
        if (this.currentStepIndex < this.steps.length - 1) {
            this.currentStepIndex++;
        } else {
            this.closeModal();
        }
    }

    prevStep() {
        if (this.currentStepIndex > 0) {
            this.currentStepIndex--;
        }
    }

    closeModal() {
        this.isVisible = false;
        this.currentStepIndex = 0;
        this.close.emit();
    }

    closeGuide() {
        this.closeModal();
    }

    skip() {
        this.closeModal();
    }
}